module.exports = __webpack_public_path__ + "85841a856fec26d9886a5932d56ba428.png";